"use client";

import Script from "next/script";

const NewRelic = () => {
  return (
    <Script
      id="newrelic-min-script"
      strategy="beforeInteractive"
      src="/next-public/amc-newrelic/amc-newrelic.min.js"
    />
  );
};

export default NewRelic;
